import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Employee } from '../../../models/employee';
import { EmployeesService } from '../../../services/employees/employees.service';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { ActionService } from '../../../services/action.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { HeaderButton } from '../../../interfaces/header-button';
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from "../../ui/spinner/spinner.component";

@Component({
  selector: 'app-employees',
  standalone: true,
  imports: [
    UserAvatarComponent, 
    RouterOutlet, 
    CommonModule, 
    SpinnerComponent
],
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss']
})
export class EmployeesComponent implements OnInit, OnDestroy {
  employees!: Employee[];
  selectedEmployee!: Employee | null;
  router!: Router;
  loading: boolean = true;
  isMobileView: boolean = false;

  constructor(
    private employeesService: EmployeesService,
    public authService: AuthenticationService,
    private actionService: ActionService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.router = _router;

    this.actionService.onButtonClick.subscribe(a => this.onHeaderButtonClick(a));

    this.employeesService.employeeUpdated.subscribe(e => this.onEmployeeUpdated(e));
  }

  ngOnInit(): void {
    this.getEmployees();

    this.actionService.addHeaderButton({
      alias: "newEmployee",
      text: "Opret medarbejder",
      iconClass: "fa-plus"
    });

    this.checkScreenSize();
  }

  ngOnDestroy(): void {
    this.actionService.removeHeaderButton("newEmployee");
  }

  @HostListener('window:resize')
  checkScreenSize() {
    this.isMobileView = window.innerWidth < 768;
  }

  private onHeaderButtonClick(btn: HeaderButton) {
    if (btn.alias === "newEmployee") {
      this.router.navigate(["create"], { relativeTo: this.route });
    }
  }

  private onEmployeeUpdated(e: Employee) {
    this.getEmployees();
  }

  getEmployees(): void {
    this.employeesService.getEmployees()
      .subscribe(employees => {
        this.employees = employees;
        this.loading = false;
      });
  }

  onSelect(employee: Employee): void {
    if (this.selectedEmployee === employee) {
        this.selectedEmployee = null;
        if (this.isMobileView) {
        this.router.navigate(['/employees']);
        }
    } else {
        this.selectedEmployee = employee;
        this.router.navigate([employee.id], { relativeTo: this.route });

        // Reset scroll to top when selecting a new employee
        setTimeout(() => {
        const scrollContainer = document.querySelector('.scrollable-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
        }, 0);
    }
  } 


    closeDetail(): void {
    this.selectedEmployee = null;
    if (this.isMobileView) {
        this.router.navigate(['/employees']);
    }

    // Reset scroll when closing detail panel
    setTimeout(() => {
        const scrollContainer = document.querySelector('.scrollable-content');
        if (scrollContainer) {
        scrollContainer.scrollTop = 0;
        }
    }, 0);
    }

}
